import React, { useState, useEffect } from "react";
import Select from "react-select";
import { CDBBtn } from 'cdbreact';

export const ModalDocManagaments = ({
  action,
  setPressedButton,
  formData,
  handleChange,
  receptions,
  setFormData,
}) => {

  if (receptions === undefined) {
    receptions = []
  }

  const receptionsSelect = receptions.map((reception) => ({
    value: `${reception.LotNumber}/*-/${reception.CodeSap}/*-/${reception.Nit}`,
    label: `Lote: ${reception.LotNumber.split("/*-/")[0]} / Código SAP: ${reception.CodeSap} / Código Proveedor: ${reception.Nit}`,
  }));

  const stateOptions = [
    { value: "Si", label: "Si" },
    { value: "No", label: "No" },
    { value: "No aplica", label: "No aplica" }
  ];

  for (const reception of receptions) {
      const [LotNumber] = reception.LotNumber.split("/*-/");
      reception.LotNumber = LotNumber;
  }
    
  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear' : 'Editando un registro'}
          </h3>
        </div>
        {action === 'edit' ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton('delete');
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="lotNumber">Número del lote:</label>
            <Select
              id="LotNumber"
              placeholder="Seleccione un lote"
              isDisabled={action === 'edit'}
              options={receptionsSelect}
              value={receptionsSelect.find((option) => option.value === `${formData.LotNumber}/*-/${formData.CodeSap}/*-/${formData.Nit}`)}
              onChange={(selectedOption) => {
                const { value } = selectedOption;
                
                const selectedReceptionData = receptions.find(reception => reception.LotNumber === value.split("/*-/")[0] 
                && reception.CodeSap === value.split("/*-/")[1]
                && reception.Nit === value.split("/*-/")[2]);

                handleChange([
                  { id: "CodeSap", value: selectedReceptionData.CodeSap },
                  { id: "LotNumber", value: selectedReceptionData.LotNumber },
                  { id: "Nit", value: selectedReceptionData.Nit }
                ]);
              }}
            />
          </div>
        </div>
        <div className="form-group">
            <label>Recepción:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="LotNumber"
              placeholder="Número del lote"
              disabled
              value={formData.LotNumber}
              onChange={handleChange}
            />
        </div>
        <div className="form-group">
            <label>Código SAP:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="CodeSap"
              placeholder="Código SAP"
              disabled
              value={formData.CodeSap}
              onChange={handleChange}
            />
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="Receipt">Hay una factura?:<span className="text-danger"> *</span></label>
          <Select
            id="Receipt"
            placeholder="Seleccione una opción"
            options={stateOptions}
            value={stateOptions.find((option) => option.value === formData.Receipt)}
            onChange={(selectedOption) =>
              handleChange([
                { id: "Receipt", value: selectedOption.value },
              ])
            }
          />
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="Remission">Hay una remisión?:<span className="text-danger"> *</span></label>
          <Select
            id="Remission"
            placeholder="Seleccione una opción"
            options={stateOptions}
            value={stateOptions.find((option) => option.value === formData.Remission)}
            onChange={(selectedOption) =>
              handleChange([
                { id: "Remission", value: selectedOption.value },
              ])
            }
          />
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="QualityCertificate">Hay un certificado de calidad?:<span className="text-danger"> *</span></label>
          <Select
            id="QualityCertificate"
            placeholder="Seleccione una opción"
            options={stateOptions}
            value={stateOptions.find((option) => option.value === formData.QualityCertificate)}
            onChange={(selectedOption) =>
              handleChange([
                { id: "QualityCertificate", value: selectedOption.value },
              ])
            }
          />
        </div>
        <div className="form-group row mb-4">
          <label htmlFor="SafetySheet">Hay una hoja de seguridad?:<span className="text-danger"> *</span></label>
          <Select
            id="SafetySheet"
            placeholder="Seleccione una opción"
            options={stateOptions}
            value={stateOptions.find((option) => option.value === formData.SafetySheet)}
            onChange={(selectedOption) =>
              handleChange([
                { id: "SafetySheet", value: selectedOption.value },
              ])
            }
          />
        </div>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('submitModal')}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};